import { Link } from 'react-router-dom';
import { events } from '@/mocks/events';
import EventCard from '@/components/feature/EventCard';
import SectionHeading from '@/components/base/SectionHeading';

export default function FeedSection() {
  const picks = events.filter((item) => item.featured).slice(0, 3);
  const latest = [...events]
    .sort((a, b) => (a.publishedAt < b.publishedAt ? 1 : -1))
    .slice(0, 6);
  const [lead, ...rest] = picks;

  return (
    <section id="events" className="scroll-mt-24 bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full px-4 md:px-6 lg:px-10">
        <SectionHeading
          eyebrow="编辑精选"
          title="这几件事，值得我们多看一眼"
          desc="编辑手动挑出的事件，脉络最清晰、后续最完整，适合从头了解一个话题。"
        />

        {lead && (
          <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
            <article className="group relative overflow-hidden rounded-lg bg-foreground-950">
              <Link to={`/events/${lead.id}`} className="block h-full" aria-hidden="true" tabIndex={-1}>
                <div className="relative h-64 w-full md:h-80 lg:h-full lg:min-h-[420px]">
                  <img
                    src={lead.cover}
                    alt={lead.title}
                    className="h-full w-full object-cover object-top opacity-80 transition-transform duration-500 group-hover:scale-[1.03]"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-foreground-950 via-foreground-950/60 to-foreground-950/10"></div>
                </div>
                <div className="absolute inset-x-0 bottom-0 p-6 md:p-8">
                  <span className="inline-flex rounded-full bg-primary-500 px-3 py-1 text-xs font-semibold text-background-50">
                    {lead.category}
                  </span>
                  <h3 className="mt-3 font-heading text-xl font-black leading-snug text-background-50 md:text-2xl">
                    {lead.title}
                  </h3>
                  <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-background-200">{lead.summary}</p>
                  <p className="mt-4 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-background-300">
                    <span>{lead.campus}</span>
                    <span>{lead.publishedAt}</span>
                    <span className="flex items-center gap-1 text-accent-300">
                      <i className="ri-fire-fill text-sm leading-none" aria-hidden="true"></i>
                      {lead.heat.toLocaleString()}
                    </span>
                  </p>
                </div>
              </Link>
            </article>

            <div className="flex flex-col gap-6">
              {rest.map((event) => (
                <EventCard key={event.id} event={event} layout="horizontal" />
              ))}
            </div>
          </div>
        )}

        <div className="mt-14 md:mt-20">
          <SectionHeading
            eyebrow="最新爆料"
            title="刚刚被同学们围观的事件"
            desc="按发布时间新鲜排序，越靠前越热乎。"
            action={{ label: '进入事件合集', to: '/events' }}
          />
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {latest.map((event) => (
              <EventCard key={event.id} event={event} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}